import React from "react";

const PasswordStrengthIndicator = ({ passwordStrengthValue }) => {
	return (
		<div className="password_indicator_container">
			{passwordStrengthValue <= 1 && (
				<div className="password_strength_indicator">
					<div className="indicator_wrapper">
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
					</div>
					<p className="indicator_message">Strength</p>
				</div>
			)}
			{passwordStrengthValue === 2 && (
				<div className="password_strength_indicator">
					<div className="indicator_wrapper">
						<div className="indicator_active" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
					</div>
					<p className="indicator_message">Very Weak</p>
				</div>
			)}
			{passwordStrengthValue === 3 && (
				<div className="password_strength_indicator">
					<div className="indicator_wrapper">
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
					</div>
					<p className="indicator_message">Weak</p>
				</div>
			)}
			{passwordStrengthValue === 4 && (
				<div className="password_strength_indicator">
					<div className="indicator_wrapper">
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_inactive" />
						<div className="indicator_inactive" />
					</div>
					<p className="indicator_message">Moderate</p>
				</div>
			)}
			{passwordStrengthValue === 5 && (
				<div className="password_strength_indicator">
					<div className="indicator_wrapper">
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_inactive" />
					</div>
					<p className="indicator_message">Good</p>
				</div>
			)}
			{passwordStrengthValue === 6 && (
				<div className="password_strength_indicator">
					<div className="indicator_wrapper">
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
					</div>
					<p className="indicator_message">Strong</p>
				</div>
			)}
			{passwordStrengthValue > 6 && (
				<div className="password_strength_indicator">
					<div className="indicator_wrapper">
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
						<div className="indicator_active" />
					</div>
					<p className="indicator_message">Very Strong</p>
				</div>
			)}
		</div>
	);
};

export default PasswordStrengthIndicator;
